// 自研都在前面加了VIPKID
// 日志记录查找信令
export const DISCOVER = {
  PING_SUCCESS: "DISCOVER_PING_SUCCESS",
  PING_FAIL: "DISCOVER_PING_FAIL",
  FETCH_WS_SERVICE_SUCCESS: "DISCOVER_FETCH_WS_SERVICE_SUCCESS",
  FETCH_WS_SERVICE_FAIL: "DISCOVER_FETCH_WS_SERVICE_FAIL",
  WS_CONNECT_0: "DISCOVER_WS_CONNECT_0",
  WS_CONNECT_1: "DISCOVER_WS_CONNECT_1",
  WS_CONNECT_2: "DISCOVER_WS_CONNECT_2",
  WS_CONNECT_3: "DISCOVER_WS_CONNECT_3",
  RESEIVE_200_SUCCESS: "DISCOVER_RESEIVE_200_SUCCESS",
  RESEIVE_200_FAIL: "DISCOVER_RESEIVE_200_FAIL",
  RESEIVE_201_SUCCESS: "DISCOVER_RESEIVE_201_SUCCESS",
  RESEIVE_201_FAIL: "DISCOVER_RESEIVE_201_FAIL",
  RESEIVE_210_FAIL: "DISCOVER_RESEIVE_210_FAIL",
  RESEIVE_15_FAIL: "DISCOVER_RESEIVE_15_FAIL",
  CONNECT_CONSUME_TIME: "DISCOVER_CONNECT_CONSUME_TIME" // 连接耗时
}
// 项目逻辑信令
export const ITC = {
  START_CONNECT: "ITC_START_CONNECT",
  PING_SUCCESS: "ITC_PING_SUCCESS",
  FETCH_WS_SERVICE_SUCCESS: "ITC_FETCH_WS_SERVICE_SUCCESS",
  CONNECTED: "ITC_CONNECTED",
  MESSAGE: "ITC_MESSAGE",
  ERROR: "ITC_ERROR",
  CLOSE: "ITC_CLOSE",
  RECORD_TIMELINE: "ITC_RECORD_TIMELINE",
  EXPORT_OUT: "EXPORT_OUT"
}
// 项目逻辑信令错误码
export const ERRORLIST = {
  EMPTY_IDC_LIST: "EMPTY_IDC_LIST",
  ABOVE_MAX_DISCOVER_TIMES: "ABOVE_MAX_DISCOVER_TIMES",
  ALL_EP_TIMEOUT: "ALL_EP_TIMEOUT",
  FETCH_WS_FAIL: "FETCH_WS_FAIL",
  CONNECT_OVER_MAXTIME_LIMIT: "CONNECT_OVER_MAXTIME_LIMIT",
  KICKOFF: "KICKOFF",
  NET_EXCEPTION: "NET_EXCEPTION",
  TOKEN_ERROR: "TOKEN_ERROR",
  USER_NOT_MATCH: "USER_NOT_MATCH",
  KEEPALIVE_FAIL: "KEEPALIVE_FAIL",
  ROUTER_FAIL: "ROUTER_FAIL",
  // 从代码中收集的常量，同时也在vipkid-signal-sdk出现的
  GET_INITROOMINFO_FAIL: "GET_INITROOMINFO_FAIL",
  // 与vipkid-signal-sdk优化对齐
  EP_NODE_OVERLOAD: "EP_NODE_OVERLOAD",
  SOCKET_CLOSE: "SOCKET_CLOSE",
  SOCKET_ERROR: "SOCKET_ERROR",
  WS_STATIC_FAIL: "WS_STATIC_FAIL"
}
// 超时消息汇总
export const TIMEROUT = {
  RESEIVE_MESSAGE_TIMEOUT: 5000,
  KEEAP_INTERVAL_TIME: 5000,
  MAX_KEEPALIVE_ERROR_COUNT: 3,
  MAX_STORE_IDC_LIST: 5,
  MAX_RETRY_TIMES: 3,
  RECONNECT_MAX_DISCOVER_TIMES: 2,
  MAX_PING_TIMES: 5,
  MAX_CONNECT_TIME: 30 * 1000 // 整个连接过程30s
}
// 日志记录信令
export const SIGNAL = {
  ENTER_SIGNAL_ROOM_SUCCESS: "ENTER_SIGNAL_ROOM_SUCCESS",
  ENTER_SIGNAL_ROOM_FAIL: "ENTER_SIGNAL_ROOM_FAIL",
  EXIT_SIGNAL_ROOM_SUCCESS: "EXIT_SIGNAL_ROOM_SUCCESS",
  RESEIVE_PPT_CHANGE_SUCCESS: "RESEIVE_PPT_CHANGE_SUCCESS",
  RESEIVE_PPT_CHANGE_FAIL: "RESEIVE_PPT_CHANGE_FAIL",
  RESEIVE_OEPN_CAMERA_SUCCESS: "RESEIVE_OEPN_CAMERA_SUCCESS",
  RESEIVE_OEPN_CAMERA_FAIL: "RESEIVE_OEPN_CAMERA_FAIL",
  RESEIVE_CLOSE_CAMERA_SUCCESS: "RESEIVE_CLOSE_CAMERA_SUCCESS",
  RESEIVE_CLOSE_CAMERA_FAIL: "RESEIVE_CLOSE_CAMERA_FAIL",
  RESEIVE_TEXT_MESSAGE_SUCCESS: "RESEIVE_TEXT_MESSAGE_SUCCESS",
  RESEIVE_TEXT_MESSAGE_FAIL: "RESEIVE_TEXT_MESSAGE_FAIL",
  RESEIVE_BROAD_MESSAGE_SUCCESS: "RESEIVE_BROAD_MESSAGE_SUCCESS",
  RESEIVE_BROAD_MESSAGE_FAIL: "RESEIVE_BROAD_MESSAGE_FAIL",
  RESEIVE_GOTO_SLIDE_SUCCESS: "RESEIVE_GOTO_SLIDE_SUCCESS",
  RESEIVE_GOTO_SLIDE_FAIL: "RESEIVE_GOTO_SLIDE_FAIL",
  RESEIVE_DRAW_LINE_SUCCESS: "RESEIVE_DRAW_LINE_SUCCESS",
  RESEIVE_DRAW_LINE_FAIL: "RESEIVE_DRAW_LINE_FAIL",
  RESEIVE_CLEAR_SUCCESS: "RESEIVE_CLEAR_SUCCESS",
  RESEIVE_CLEAR_FAIL: "RESEIVE_CLEAR_FAIL",
  RESEIVE_START_PUBLIC_VOTE_SUCCESS: "RESEIVE_START_PUBLIC_VOTE_SUCCESS",
  RESEIVE_START_PUBLIC_VOTE_FAIL: "RESEIVE_START_PUBLIC_VOTE_FAIL",
  RESEIVE_SUBMIT_PUBLIC_VOTE_SUCCESS: "RESEIVE_SUBMIT_PUBLIC_VOTE_SUCCESS",
  RESEIVE_SUBMIT_PUBLIC_VOTE_FAIL: "RESEIVE_SUBMIT_PUBLIC_VOTE_FAIL",
  RESEIVE_COLLECT_PUBLIC_VOTE_SUCCESS: "RESEIVE_COLLECT_PUBLIC_VOTE_SUCCESS",
  RESEIVE_COLLECT_PUBLIC_VOTE_FAIL: "RESEIVE_COLLECT_PUBLIC_VOTE_FAIL",
  RESEIVE_INIT_VIDEO_MP4_SUCCESS: "RESEIVE_INIT_VIDEO_MP4_SUCCESS",
  RESEIVE_INIT_VIDEO_MP4_FAIL: "RESEIVE_INIT_VIDEO_MP4_FAIL",
  RESEIVE_PLAY_VIDEO_MP4_SUCCESS: "RESEIVE_PLAY_VIDEO_MP4_SUCCESS",
  RESEIVE_PLAY_VIDEO_MP4_FAIL: "RESEIVE_PLAY_VIDEO_MP4_FAIL",
  RESEIVE_PAUSE_VIDEO_MP4_SUCCESS: "RESEIVE_PAUSE_VIDEO_MP4_SUCCESS",
  RESEIVE_PAUSE_VIDEO_MP4_FAIL: "RESEIVE_PAUSE_VIDEO_MP4_FAIL",
  RESEIVE_CLOSE_VIDEO_MP4_SUCCESS: "RESEIVE_CLOSE_VIDEO_MP4_SUCCESS",
  RESEIVE_CLOSE_VIDEO_MP4_FAIL: "RESEIVE_CLOSE_VIDEO_MP4_FAIL",
  RESEIVE_SEEK_VIDEO_MP4_SUCCESS: "RESEIVE_SEEK_VIDEO_MP4_SUCCESS",
  RESEIVE_SEEK_VIDEO_MP4_FAIL: "RESEIVE_SEEK_VIDEO_MP4_FAIL",
  RESEIVE_TRANSPORT_DATA_SUCCESS: "RESEIVE_TRANSPORT_DATA_SUCCESS",
  RESEIVE_TRANSPORT_DATA_FAIL: "RESEIVE_TRANSPORT_DATA_FAIL",
  INIT_BROAD_EVENT: "INIT_BROAD_EVENT",
  RESEIVE_SEND_SWITCH_VIDEO_PPT_SUCCESS:
    "RESEIVE_SEND_SWITCH_VIDEO_PPT_SUCCESS",
  RESEIVE_SEND_SWITCH_VIDEO_PPT_FAIL: "RESEIVE_SEND_SWITCH_VIDEO_PPT_FAIL",
  RESEIVE_SEND_HONGBAO_SUCCESS: "RESEIVE_SEND_HONGBAO_SUCCESS",
  RESEIVE_SEND_HONGBAO_FAIL: "RESEIVE_SEND_HONGBAO_FAIL"
}
// 日志打印媒体
export const LIVE = {
  ENTER_LIVE_ROOM_SUCCESS: "ENTER_LIVE_ROOM_SUCCESS",
  ENTER_LIVE_ROOM_FAIL: "ENTER_LIVE_ROOM_FAIL",
  EXIT_LIVE_ROOM_SUCCESS: "EXIT_LIVE_ROOM_SUCCESS",
  EXIT_LIVE_ROOM_FAIL: "EXIT_LIVE_ROOM_FAIL",
  GET_DEVICE_SUCCESS: "GET_DEVICE_SUCCESS",
  GET_DEVICE_FAIL: "GET_DEVICE_FAIL",
  GET_MEDIASTREAM_SUCCESS: "GET_MEDIASTREAM_SUCCESS",
  GET_MEDIASTREAM_FAIL: "GET_MEDIASTREAM_FAIL",
  GET_SHOW_MEDIASTREAM_SUCCESS: "GET_SHOW_MEDIASTREAM_SUCCESS",
  GET_SHOW_MEDIASTREAM_FAIL: "GET_SHOW_MEDIASTREAM_FAIL",
  PUBLISH_MEDIASTREAM_SUCCESS: "PUBLISH_MEDIASTREAM_SUCCESS",
  PUBLISH_MEDIASTREAM_FAIL: "PUBLISH_MEDIASTREAM_FAIL",
  UN_PUBLISH_MEDIASTREAM_SUCCESS: "UN_PUBLISH_MEDIASTREAM_SUCCESS",
  UN_PUBLISH_MEDIASTREAM_FAIL: "UN_PUBLISH_MEDIASTREAM_FAIL",
  SUBSCRIBE_MEDIASTREAM_SUCCESS: "SUBSCRIBE_MEDIASTREAM_SUCCESS",
  SUBSCRIBE_MEDIASTREAM_FAIL: "SUBSCRIBE_MEDIASTREAM_FAIL",
  UN_SUBSCRIBE_MEDIASTREAM_SUCCESS: "UN_SUBSCRIBE_MEDIASTREAM_SUCCESS",
  UN_SUBSCRIBE_MEDIASTREAM_FAIL: "UN_SUBSCRIBE_MEDIASTREAM_FAIL",
  PLAY_MEDIA_SUCCESS: "PLAY_MEDIA_SUCCESS",
  PLAY_MEDIA_FALIED: "PLAY_MEDIA_FALIED",
  PLAY_SHOW_MEDIA_SUCCESS: "PLAY_SHOW_MEDIA_SUCCESS",
  PLAY_SHOW_MEDIA_FALIED: "PLAY_SHOW_MEDIA_FALIED",
  STOP_MEDIA_SUCCESS: "STOP_MEDIA_SUCCESS",
  CLOSE_MEDIA_SUCCESS: "CLOSE_MEDIA_SUCCESS",
  GET_AUDIO_LEVEL_SUCCESS: "GET_AUDIO_LEVEL_SUCCESS",
  ENABLE_VIDEO_SUCCESS: "ENABLE_VIDEO_SUCCESS",
  DISABLED_VIDEO_SUCCESS: "DISABLED_VIDEO_SUCCESS",
  ENABLE_AUDIO_SUCCESS: "ENABLE_AUDIO_SUCCESS",
  DISABLED_AUDIO_SUCCESS: "DISABLED_AUDIO_SUCCESS" // 关闭麦克风
}
// 日志打印媒体
export const LIVE_VIPKID = {}
// webserver
export const ENGINE = {
  // INIT_MEDIA_ENGINE_SUCCESS: "INIT_MEDIA_ENGINE_SUCCESS", //初始化第三方媒体SDK成功
  // INIT_MEDIA_ENGINE_FAIL: "INIT_MEDIA_ENGINE_FAIL" //初始化第三方媒体SDK失败
  MEDIA_ENTER_WEBSERVER_SUCCESS: "MEDIA_ENTER_WEBSERVER_SUCCESS",
  MEDIA_ENTER_WEBSERVER_FAIL: "MEDIA_ENTER_WEBSERVER_FAIL",
  SIGNAL_ENTER_WEBSERVER_SUCCESS: "SIGNAL_ENTER_WEBSERVER_SUCCESS",
  SIGNAL_ENTER_WEBSERVER_FAIL: "SIGNAL_ENTER_WEBSERVER_FAIL" // 进入信令失败
}

export const MESSAGE = {}
// let apiURL
// if (window.location.origin.indexOf("localhost") > 0) {
//   apiURL =
//     "https://qa-gw-openclass.vipkid-qa.com.cn/api/vps/service/openclass/gslb/ec"
// }
// if (window.location.origin.indexOf("stage") > 0) {
//   apiURL =
//     "https://qa-gw-openclass.vipkid-qa.com.cn/api/vps/service/openclass/gslb/ec"
// }

// 第三方媒体类型
export const MBS_VENDOR = "mbs"
export const AGORA_VENDOR = "agora"
export const DUOBEI_VENDOR = "doubei"

// 日志记录'
export var LogLevels
;(function(LogLevels) {
  LogLevels["INFO"] = "INFO"
  LogLevels["WARNING"] = "WARNING"
  LogLevels["ERROR"] = "ERROR"
})(LogLevels || (LogLevels = {}))
export const LOG = {
  INFO: LogLevels.INFO,
  WARNING: LogLevels.WARNING,
  ERROR: LogLevels.ERROR
}
